var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StatsComp',{ref:"stats"}),_c('QuestionComp',{ref:"question",on:{"answer":_vm.answer}}),(_vm.answered)?_c('v-btn',{on:{"click":_vm.newQuestion}},[_vm._v("\n        Next\n    ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }